import { ReferencePagesNavigation } from "src/components/ReferencePagesNavigation";

export const ReferencePagesNavigationBlock = () => {
  return <ReferencePagesNavigation />;
};
